import React, { Component, createRef } from "react";
import { createPortal } from "react-dom";
import { withTranslation } from "react-i18next";

class Helper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTooltip: false,
      position: { top: 0, left: 0 },
    };
    this.iconRef = createRef();
  }

  showTooltip = () => {
    if (!this.iconRef.current) return;
    const rect = this.iconRef.current.getBoundingClientRect();

    // Detectar el zoom del body. Si no está definido, asumimos 1.
    let zoom = 1;
    const zoomStyle = document.body.style.zoom;
    if (zoomStyle) {
      zoom = zoomStyle.endsWith("%")
        ? parseFloat(zoomStyle) / 100
        : parseFloat(zoomStyle);
      if (!zoom) zoom = 1;
    }

    // Punto central horizontal, debajo del trigger
    const offset = 8; // distancia entre el trigger y el tooltip
    const top =
      (rect.top + window.scrollY - offset) / zoom; // Aparece encima del trigger
    const left =
      (rect.left + window.scrollX + rect.width / 2) / zoom; // Centrado al trigger

    this.setState({
      showTooltip: true,
      position: { top, left },
    });
  };

  hideTooltip = () => {
    this.setState({ showTooltip: false });
  };

  renderTooltip() {
    const { t, text } = this.props;
    const { showTooltip, position } = this.state;
    if (!showTooltip) return null;

    return createPortal(
      <div
        style={{
          position: "absolute",
          top: position.top,
          left: position.left,
          transform: "translate(-50%, -100%)", // Aparece encima del trigger, centrado horizontalmente
          zIndex: 9999,
          pointerEvents: "none",
        }}
      >
        <div
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            color: "#fff",
            padding: "6px 10px",
            borderRadius: "4px",
            fontSize: "0.775rem",
            width: "210px",
            textAlign: "center",
            boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
            marginBottom: "5px", // Espacio para la flecha
            pointerEvents: "none",
          }}
        >
          {t(text)}
        </div>
        <div
          style={{
            position: "relative",
            width: "100%",
            height: 0,
            display: "flex",
            justifyContent: "center",
            pointerEvents: "none",
          }}
        >
          <div
            style={{
              width: 0,
              height: 0,
              borderLeft: "5px solid transparent",
              borderRight: "5px solid transparent",
              borderTop: "5px solid rgba(0, 0, 0, 0.75)",
            }}
          />
        </div>
      </div>,
      document.body
    );
  }

  render() {
    return (
      <span
        ref={this.iconRef}
        style={{
          display: "inline-block",
          position: "relative",
        }}
        onMouseEnter={this.showTooltip}
        onMouseLeave={this.hideTooltip}
      >
        <div
          style={{
            background: "#59B089",
            color: "#fff",
            cursor: "pointer",
            width: 20,
            height: 20,
            lineHeight: "24px",
            fontSize: 14,
            borderRadius: 5,
            textAlign: "center",
            userSelect: "none",
          }}
        >
          <b>!</b>
        </div>
        {this.renderTooltip()}
      </span>
    );
  }
}

export default withTranslation()(Helper);
